import { AfterViewInit, Component, ComponentFactoryResolver, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [
    trigger('sidebarAnimation', [
      state('open', style({ transform: 'translateX(0%)', visibility: 'visible' })), // Sidebar is visible
      state('closed', style({ transform: 'translateX(100%)', visibility: 'hidden' })), // Sidebar is off-screen

      transition('closed => open', [
        animate('300ms ease-in-out') // Open animation
      ]),
      transition('open => closed', [
        animate('300ms ease-in-out') // Close animation
      ])
    ])
  ]
})
export class SidebarComponent implements OnInit, OnChanges, OnDestroy {
  @Input() title: string = '';
  @Input() isOpen: boolean = false;
  @Input() close: () => void = () => {};
  @Input() mode: 'overlay' | 'push' = 'overlay';  // NEW: Determines behavior
  @Input() componentType!: Type<any> | null;  // Component to load
  @Input() componentInputs: { [key: string]: any } = {};  // Inputs to pass

  @ViewChild('sidebarContent', { read: ViewContainerRef }) sidebarContent!: ViewContainerRef;

  public isAnimating = false;

  constructor(private resolver: ComponentFactoryResolver) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.isAnimating = false; // Ensure cleanup
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpen']) {
      if (this.isOpen) {
        this.isAnimating = true;
        setTimeout(() => (this.isAnimating = false), 300); // Animation duration
      }
    }
    if (changes['componentType'] && this.componentType) {
      this.loadComponent();
    }
  }

  get sidebarState() {
    return this.isOpen ? 'open' : 'closed';
  }

  loadComponent() {
    if (!this.sidebarContent || !this.componentType) return;

    this.sidebarContent.clear();
    const factory = this.resolver.resolveComponentFactory(this.componentType);
    const componentRef = this.sidebarContent.createComponent(factory);

    // Pass inputs dynamically
    Object.keys(this.componentInputs).forEach((key) => {
      componentRef.instance[key] = this.componentInputs[key];
    });
  }

}
